import React, { useState } from 'react';
import { Autocomplete, Chip, TextField } from "@mui/material";
import { idNamingConversion } from '../../../../../helpers/utilities';
import { splitSerialNos, uniqueSerialNos } from './utils';

/*
 * Chip input for invoice numbers. A number is committed on Enter, comma, space or blur, and a
 * pasted list (e.g. a column copied from Excel) is split into chips - a plain text input would
 * silently strip the line breaks and merge the numbers.
 */
export const InvoiceInput = ({ value, onChange, disabled, error, classes }) => {
    const [draft, setDraft] = useState('');

    const commit = (text) => {
        const added = splitSerialNos(text);
        if (added.length > 0) onChange(uniqueSerialNos([...value, ...added]));
        setDraft('');
    };

    return (
        <Autocomplete
            multiple
            freeSolo
            disableClearable
            options={[]}
            value={value}
            inputValue={draft}
            disabled={disabled}
            onChange={(e, next) => onChange(uniqueSerialNos(next.flatMap(splitSerialNos)))}
            onInputChange={(e, next, reason) => {
                if (reason === 'reset') setDraft('');
                else if (/[\s,;]/.test(next)) commit(next);
                else setDraft(next);
            }}
            className={classes.chipInput}
            renderTags={(tags, getTagProps) => tags.map((tag, index) => (
                <Chip {...getTagProps({ index })} key={tag} label={tag} size="small" className={classes.chip} />
            ))}
            renderInput={(params) => (
                <TextField
                    {...params}
                    error={error}
                    placeholder={value.length === 0 ? 'Type an invoice number and press Enter, or paste a list' : 'Add more…'}
                    id={idNamingConversion('Invoice Numbers', 'gstRecalculation', 'TextField')}
                    inputProps={{
                        ...params.inputProps,
                        'aria-label': 'Invoice numbers',
                        onPaste: (e) => {
                            const text = e.clipboardData.getData('text');
                            if (/[\s,;]/.test(text.trim())) {
                                e.preventDefault();
                                commit(draft + text);
                            }
                        },
                        onBlur: (e) => {
                            params.inputProps.onBlur?.(e);
                            if (draft.trim()) commit(draft);
                        },
                    }}
                />
            )}
            open={false}
        />
    );
};
